import createTranslateFunction from '../../i18n/createTranslateFunction';
import { OrderStatusObject } from '../../redux/slices/ordersSlice';
import { useSelector } from '../../redux/store';

type StatusContainerProps = {
    containerStatusValue: number;
    isOrderDelivery: boolean;
};

const StatusContainer = ({ containerStatusValue, isOrderDelivery }: StatusContainerProps) => {
    //Made two different translation functions for delivery and pickup status containers
    const DeliveryStatusContainerTranslation = createTranslateFunction(
        'track_order.delivery_statuses',
    );
    const PickupStatusContainerTranslation = createTranslateFunction('track_order.pickup_statuses');
    const { last_order_converted_status } = useSelector((state) => state.orders);

    const isCurrentStatusSelected =
        OrderStatusObject[containerStatusValue] === last_order_converted_status;

    const getContainerStatusValue = () => {
        switch (containerStatusValue) {
            case 0:
                return 1;
            case 1:
                return 2;
            case 2:
                return 3;
            case 3:
                return 3;
            case 4:
                if (isOrderDelivery) {
                    return 4;
                } else {
                    return 3;
                }
            default:
                return 0;
        }
    };
    const getOrderTranslation = () => {
        if (isOrderDelivery) {
            return DeliveryStatusContainerTranslation(OrderStatusObject[containerStatusValue]);
        }
        return PickupStatusContainerTranslation(`${OrderStatusObject[containerStatusValue]}`);
    };
    return (
        <div
            className={`!z-[5] w-[37vw] my-[1vw] h-[5.6vw] px-[2vw] flex items-center text-center bg-[#ffffff2c] rounded-[2vw] ${isCurrentStatusSelected && '!bg-pizzahut-red'}`}
        >
            <span
                className={`w-[3.5vw] h-[3.5vw] flex justify-center items-center text-[1.8vw] rounded-full bg-pizzahut-red ml-[2vw] ${isCurrentStatusSelected && 'bg-white text-pizzahut-red'}`}
            >
                {getContainerStatusValue()}
            </span>
            <span className="text-[1.6vw]">{getOrderTranslation()}</span>
        </div>
    );
};

export default StatusContainer;
